import MuiBox from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { designTokenToColor } from '@src/utils';
import { getTestId } from '@src/utils/testIds';
import React from 'react';
import { Box } from '../Box';
import { InternalBox } from '../Box/InternalBox';
import { Text } from '../Typography';
import type { ProgressIndicatorProps } from './interface';
import { displayableProgress } from './util';

export function ProgressIndicator(props: ProgressIndicatorProps) {
  const { progress } = props;
  const { displayValue, validatedValue } = displayableProgress(progress);

  return (
    <Box testId={getTestId(props)}>
      <MuiBox position="relative" display="inline-flex">
        <CircularProgress
          variant="determinate"
          value={validatedValue}
          size="100px"
          sx={{
            '.MuiCircularProgress-circle': { color: designTokenToColor('state.teal.secondary') },
          }}
        />
        <InternalBox
          position="absolute"
          top={0}
          left={0}
          right={0}
          // Perfect center is not perceived as center, so we adjust bottom slightly
          bottom={4}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <Text size="m" color="text.secondary">
            {displayValue}
          </Text>
          <Text size="m" color="text.secondary">
            Complete
          </Text>
        </InternalBox>
      </MuiBox>
    </Box>
  );
}
